<div class="px-2">
    <div *ngFor="let subsection of selectedSectionDetail.sections; let i = index">
        <div class="py-2 pl-1 bg-light section-heading">
            {{subsection.name}}
        </div>
        <div class="pb-4 pt-3">
            <img src={{subsection.data.image}} class="img-thumbnail full-img">
        </div>
    </div>
</div>